import * as Sentry from '@sentry/react';

export function initSentry() {
  Sentry.init({
    dsn: window.PORTAL_SENTRY_UI_DSN || import.meta.env.VITE_SENTRY_UI_DSN,
    environment: window.PORTAL_ENV || import.meta.env.VITE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate:
      Number(window.PORTAL_SENTRY_TRACES_SAMPLE_RATE)
      || Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    tracePropagationTargets:
      window.PORTAL_SENTRY_TRACE_PROPAGATION_TARGETS
      || import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS,
    normalizeDepth: 10,
    maxBreadcrumbs: 50,
  });
}
